/*
 * Copyright (c) 2020. American Express Company
 */

import React, { Component, ReactComponentElement } from 'react';

// models and services
import { CardModel } from 'src/types/card.model';
import CashFlowService from '../../services/cashflow.service';
import LiteralsService from '../../services/literals/LiteralsService';
import { LocalDate } from '@js-joda/core';

// components
import GoalDrawer from './GoalDrawer';
import InfoCallout from '../callout/InfoCallout';

// icons and styles
import { ReactComponent as EndOfLifeIcon } from 'src/bw/goal/end-of-life.svg';
import { ReactComponent as OilBarrelIcon } from 'src/bw/goal/oil-barrel.svg';
import { ReactComponent as StockBoomIcon } from 'src/bw/goal/stock-boom.svg';
import { ReactComponent as StockCrashIcon } from 'src/bw/goal/stock-crash.svg';
import { HELP_DOMAIN } from 'src/utils/constants';

export default class DateGoalDrawer extends Component<any, any> {
    public override render(): ReactComponentElement<any> {
        const drawerProps: any = this.props.drawerProps;

        const card: CardModel = drawerProps.card;

        let description: JSX.Element;
        let calloutText: string = '';
        let icon: JSX.Element = null;
        const startDateLabel: string = LiteralsService.getLiteral('DateGoalDrawer.startDateLabel');
        let learnMoreContent: JSX.Element = LiteralsService.getJsxLiteral('DateGoalDrawer.learnMore');
        let learnMoreUrl: string = HELP_DOMAIN ? HELP_DOMAIN + '/articles/projections' : null;

        let endDate: LocalDate = CashFlowService.getLastCashFlow(this.props.user.cashFlow).endDate;

        switch (card.description) {
            case '2008 crash':
                description = LiteralsService.getJsxLiteral('DateGoalDrawer.2008.intro');
                calloutText =
                    'This event is helpful if you want to see how your portfolio looks in the event of a' +
                    ' market' +
                    ' crash.';
                icon = <StockCrashIcon />;
                break;
            case '2010 boom':
                description = LiteralsService.getJsxLiteral('DateGoalDrawer.2010.intro');
                calloutText =
                    'This event is helpful if you want to see how your portfolio looks if the market takes' + ' off.';
                icon = <StockBoomIcon />;
                break;
            case 'oil shock':
                description = LiteralsService.getJsxLiteral('DateGoalDrawer.oil.intro');
                calloutText =
                    'This event is helpful if you want to estimate how your portfolio would behave in the' +
                    ' event' +
                    ' of moderate oil shock to the global economy.';
                icon = <OilBarrelIcon />;
                break;
            case 'end of life':
                description = LiteralsService.getJsxLiteral('DateGoalDrawer.eol.intro');
                icon = <EndOfLifeIcon />;
                learnMoreContent = LiteralsService.getJsxLiteral('DateGoalDrawer.eol.learnMore');
                learnMoreUrl = HELP_DOMAIN ? HELP_DOMAIN + '/articles/end-of-life' : null;
                if (this.props.user.dob) {
                    endDate = this.props.user.dob.plusYears(120);
                }
                break;
        }

        return (
            <GoalDrawer
                drawerProps={drawerProps}
                handleBack={this.props.handleBack}
                handleUpdateCard={this.props.handleUpdateCard}
                handleChangeCard={this.props.handleChangeCard}
                handleDeleteCard={this.props.handleDeleteCard}
                showLoader={this.props.showLoader}
                hideLoader={this.props.hideLoader}
                icon={icon}
                introContent={description}
                cashFlow={this.props.user.cashFlow}
                handleChangeCardDate={this.props.handleChangeCardDate.bind(this)}
                learnMoreContent={learnMoreContent}
                learnMoreUrl={learnMoreUrl}
                startDateLabel={startDateLabel}
                updateAction={() => (card.attributes.updated = Date.now())}
                maxEndDate={endDate}
            >
                {calloutText && <InfoCallout text={calloutText} noMargin />}
            </GoalDrawer>
        );
    }
}
